// extracted by mini-css-extract-plugin
export var estates = "PageInvestmentProperty-module--estates--Ytmu3";
export var materialTitle = "PageInvestmentProperty-module--materialTitle--lRxUw";
export var preamble = "PageInvestmentProperty-module--preamble--yw-i5";